import React from "react";
import { LinkInfo } from "../models/shared/LinkInfo";
import { isNullOrWhiteSpace } from "../shared/string";
import LinkWithArrow from "./LinkWithArrow";
import { PortableTextColorThemeProps } from "./PortableText/PortableText";

export interface CardListProps {
  children: React.ReactNode;
  displayLink?: boolean;
  gridBreakpointStyle?: "row" | "column";
  liClassName?: string;
  parentLink: LinkInfo;
  portableTextColorThemeProps?: PortableTextColorThemeProps;
  subtitle?: string;
  title?: string;
}

const CardList: React.FC<CardListProps> = ({
  children,
  displayLink,
  gridBreakpointStyle,
  liClassName,
  parentLink,
  portableTextColorThemeProps,
  subtitle,
  title
}) => {
  const {
    elementClasses: { h3Subheader: subtitleClasses = "text-subheader-primary" } = {}
  } = portableTextColorThemeProps || {};

  let gridClassNames: string;
  if (gridBreakpointStyle === "row") {
    gridClassNames =
      "grid-rows-1 grid-flow-col lg:grid-flow-row lg:grid-cols-3 overflow-x-auto";
  } else {
    gridClassNames = "grid-cols-1 lg:grid-cols-3";
  }

  return (
    <aside className="px-0 overflow-hidden">
      {!isNullOrWhiteSpace(title) && <h2 className="text-current px-4 mb-2">{title}</h2>}
      {!isNullOrWhiteSpace(subtitle) && (
        <h3 className={`${subtitleClasses} px-4 mb-6`}>{subtitle}</h3>
      )}
      <ul className={`px-4 pt-2 pb-12 grid gap-8 ${gridClassNames}`}>
        {React.Children.map(children, (card, index) => (
          <li
            key={index}
            className={`card-basic group hover:border-brand-primary-70 focus:outline-none focus:shadow-card-outline flex-1 min-w-card-small items-center ${
              liClassName ?? ""
            }`}
          >
            {card}
          </li>
        ))}
      </ul>
      {displayLink ? (
        <div className="flex items-center justify-end w-full mx-auto px-4 md:px-6 lg:px-12">
          <LinkWithArrow linkInfo={parentLink} />
        </div>
      ) : null}
    </aside>
  );
};

export default CardList;
